import React from 'react';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js';
import { Bar } from 'react-chartjs-2';

// Register Chart.js components
ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);

const ScanScoreChart = ({ scanData, isDark = false }) => {
  // Function to get color based on percentage
  const getColor = (percentage) => {
    if (percentage <= 50) return '#ff4d4f'; // Red
    if (percentage <= 70) return '#faad14'; // Orange
    return '#52c41a'; // Green
  };

  // Custom plugin to handle rounded top corners only
  const roundedTopPlugin = {
    id: 'roundedTop',
    beforeDraw: (chart) => {
      const ctx = chart.ctx;
      chart.data.datasets.forEach((dataset, datasetIndex) => {
        const meta = chart.getDatasetMeta(datasetIndex);
        meta.data.forEach((bar, index) => {
          const { x, y, width, height } = bar;
          ctx.save();
          ctx.beginPath();
          ctx.roundRect(x - width/2, y, width, height, [8, 8, 0, 0]);
          ctx.clip();
          ctx.fillStyle = dataset.backgroundColor[index];
          ctx.fillRect(x - width/2, y, width, height);
          ctx.restore();
        });
      });
    }
  };

  // Prepare chart data
  const chartData = {
    labels: ['Financial Strength', 'Governance', 'Market Activity', 'Complexity'],
    datasets: [
      {
        label: 'Score',
        data: [
          scanData?.financialStrength || 0,
          scanData?.governance || 0,
          scanData?.marketActivity || 0,
          scanData?.complexity || 0,
        ],
        backgroundColor: [
          getColor(scanData?.financialStrength || 0),
          getColor(scanData?.governance || 0),
          getColor(scanData?.marketActivity || 0),
          getColor(scanData?.complexity || 0),
        ],
        borderColor: [
          getColor(scanData?.financialStrength || 0),
          getColor(scanData?.governance || 0),
          getColor(scanData?.marketActivity || 0),
          getColor(scanData?.complexity || 0),
        ],
        borderWidth: 1,
        borderRadius: 8,
        borderSkipped: false,
        maxBarThickness: 70,
      },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        display: false,
      },
      title: {
        display: false,
      },
      tooltip: {
        backgroundColor: isDark ? 'rgba(42, 42, 62, 0.95)' : 'rgba(0, 0, 0, 0.8)',
        titleColor: isDark ? '#ffffff' : '#fff',
        bodyColor: isDark ? '#ffffff' : '#fff',
        borderColor: isDark ? '#4a4a5e' : '#fff',
        borderWidth: 1,
        cornerRadius: 8,
        displayColors: false,
        callbacks: {
          label: function(context) {
            return `${context.label}: ${context.parsed.y.toFixed(1)}`;
          }
        }
      },
    },
    scales: {
      x: {
        grid: {
          display: false,
        },
        ticks: {
          color: isDark ? 'rgba(255, 255, 255, 0.8)' : '#666',
          font: {
            size: 12,
            weight: '500',
          },
        },
        categoryPercentage: 0.6,
        barPercentage: 0.4,
        maxBarThickness: 70,
      },
      y: {
        beginAtZero: true,
        max: 100,
        grid: {
          display: false,
        },
        ticks: {
          color: isDark ? 'rgba(255, 255, 255, 0.8)' : '#666',
          font: {
            size: 12,
          },
          stepSize: 20,
          callback: function(value) {
            return value;
          }
        },
      },
    },
    elements: {
      bar: {
        borderRadius: 0,
      },
    },
  };

  return (
    <div style={{ height: '500px', width: '80%' }} className="scan-score-chart">
      <Bar data={chartData} options={options} plugins={[roundedTopPlugin]} />
    </div>
  );
};

export default ScanScoreChart;
